module.exports = __webpack_public_path__ + "img/fronx-ta-blanco-invierno.0b23634d.png";